/* eslint-disable camelcase */
import { defineStore } from "pinia";
import fetchWrapper from "../helpers/fetchWrapper";

export const useConsultantDashboardStore = defineStore("consultantDashboard", {
  // arrow function recommended for full type inference
  state: () => {
    return {
      // all these properties will have their type inferred automatically
      loading: true,
      error: false,
      data: {
        no_of_pending_returns: 0,
        no_of_returns_filed: 0,
        no_of_clients: 0,
        portfolio_of_clients: {
          mainland_client: 0,
          freezone_client: 0
        },
        marquee_text: []
      }
    };
  },
  actions: {
    async getDashboardItems(id) {
      try {
        this.loading = true;
        const res = await fetchWrapper.get(`/dashboard${id ? "/" + id : ""}`);
        if (res.data.result == 1) {
          this.data = {
            ...res.data?.data,
            entity_id: String(res.data?.data?.entity_id)
          };
          this.error = false;
          this.loading = false;
        } else {
          this.error = res.data?.error
            ? res.data?.error?.join(",")
            : res.data?.message;
          this.loading = false;
        }
      } catch (err) {
        console.log(err);
        this.error = err?.response?.data?.message || "";
        this.loading = false;
      }
    }
  }
});
